import {FC, SVGProps} from 'react';

/** Стилизоваванная галочка для success-модалки (слот illustration ConfirmationModal). */
export const ConfirmationSuccessIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="72"
		height="88"
		viewBox="0 0 72 88"
		fill="none"
		aria-hidden
		{...props}
	>
		<g transform="rotate(12 36 44)">
			<path
				d="M10 45.5L27.5 66L62 18"
				stroke="#fff"
				strokeWidth="20"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10 45.5L27.5 66L62 18"
				stroke="#121212"
				strokeWidth="13"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
);
